import { Component } from '@angular/core';
import { BaseDialogComponent } from '../base/base-dialog/base-dialog.component';

@Component({
  selector: 'dp-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent extends BaseDialogComponent {

}
